import { Button, Card, Checkbox, Collapse, Divider, Empty, Icon, List, Modal, Popover, Progress, Select, Spin, Tooltip } from 'antd'
import React, { ComponentType, FC, useMemo, useRef, useState } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import HttpService from 'src/core/services/http.service'
import { container } from 'src/inversify.config'
import { IdentityProps, withIdentity } from 'src/core/services/authentication'
import { TimesheetItem, TimesheetSummary } from 'src/stores/timesheets-store'
import { MyTimesheetsStore } from 'src/stores/my-timesheets-store'
import { UserProfileProps, withUserProfile } from 'src/components/user-profile'
import { formatDecimal, unixEpochToDate } from 'src/core/utils/object'
import moment from 'moment'
import { init } from 'i18next'
import { GroupData } from 'src/components/grouped-list'
import { StatusView } from 'src/components/timesheet'
import i18n from 'src/i18n'
import { time } from 'console'
import { id } from 'inversify'
import { ProjectSummary } from 'src/stores/projects-store'
import { dropdownRender } from '../../../core/ui/form/select-sign'
import { Query } from '../../../core/stores/dataStore'
const Panel = Collapse.Panel
const { Option } = Select





export interface TimeSheetCalendarItem {
  open: boolean
  month: number
  monthTitle: string
  timesheets: TimesheetItem[]
}
export interface TimeSheetCalendarProps extends WithTranslation, IdentityProps, UserProfileProps {
  employeeId: string,
  companyId: string,
  onSelectTimeSheet?: (timesheet?: TimesheetItem) => void
  reload: number
  reloadProject: number,
  fullReaload: number
  selectedTimesheetHasChanges: boolean
}



const TimeSheetCalendar: FC<TimeSheetCalendarProps> = (props) => {
  const { t } = props
  const timesheetDataStore = container.get<MyTimesheetsStore>(MyTimesheetsStore)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [years, setYears] = useState<number[]>()
  const [selectedYears, setSelectedYears] = useState<string | string[]>([])
  const [minDate, setMinDate] = useState<Date>()
  const [maxDate, setMaxDate] = useState<Date>()
  const [selectedTimesheets, setSelectedTimeSheets] = useState<TimesheetItem[]>([])
  const [projects, setProjects] = useState<ProjectSummary[]>([])
  const [total, setTotal] = useState(0)

  const [periodFilter, setPeriodFilter] = useState<string[]>([])
  const [sortDirection, setSordirection] = useState<"asc" | "desc">("desc")
  const [sortBy, setSortBy] = useState<"date" | "progress">("date")
  const [projectFilter, setProjectFilter] = useState<string[] | undefined>(undefined)
  const [statusFilter, setStatusFilter] = useState<string[] | undefined>(undefined)
  const [incompletes, setIncompletes] = useState<boolean>(false)
  const [showFilter, setShowFilter] = useState(true)
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)
  const [toSelectTimesheet, SetToSelectTimesheet] = useState<TimesheetItem>()
  const [loading, setLoading] = useState<boolean>(true)
  const [search, setSearch] = useState('')

  const loadProjects = async () => {
    setLoading(true)
    var query: Query = {
      searchQuery: search || '',
      skip: 0,
      take: 10,
      orderBy: [{ field: 'Title', direction: 'Ascending', useProfile: false }]
    }
    var pro = await timesheetDataStore.getProjects(query, props.companyId)
    const items = pro.items as ProjectSummary[]
    setTotal(pro.count)
    setProjects(items)
    setLoading(false)
  }

  var ref = useRef()

  const projectFilterSource = () => {
    let ans: string[] = []
    for (let i = 0; i < projects.length; i++) {
      ans.push(projects[i].title)
    }
    return ans.distinct(x => x).toArray() as string[]
  }

  const BuildCalendar = (min: number, max: number) => {
    let initYear = moment(unixEpochToDate(min)).toDate().getFullYear()
    setMinDate(moment(unixEpochToDate(min)).toDate())
    setMaxDate(moment(unixEpochToDate(max)).toDate())
    let currentYear = moment(unixEpochToDate(max)).toDate().getFullYear()
    let periods: number[] = []

    do {
      periods.push(currentYear)

    } while (initYear < currentYear--)

    if (periods.length > 0) {
      setSelectedYears([periods[0] + ""])
    }
    setYears(periods)
  }

  const customPanelStyle = {
    borderRadius: 1,
    marginBottom: 2,
    width: "100%",

    border: 0,
  }
  const Load = async () => {

    var mm = await timesheetDataStore.getMaxMIn(props.companyId, props.employeeId, false, projectFilter) as any
    BuildCalendar(mm.item1, mm.item2)
    setIsLoading(false)
  }

  const FilterYears = () => {
    if (!periodFilter || periodFilter.length == 0)
      return years || []
    else
      return years?.filter(x => periodFilter.any(y => y == x + "")) || []

  }

  useMemo(() => {
    if (props.reloadProject > 0) {
      setSearch('')
    }
  }, [props.reloadProject]) // eslint-disable-line react-hooks/exhaustive-deps

  useMemo(() => {
    Load()

  }, [ref]) // eslint-disable-line react-hooks/exhaustive-deps

  useMemo(() => {
    loadProjects()

  }, [search]) // eslint-disable-line react-hooks/exhaustive-deps

  useMemo(() => {
    setShowFilter(!props.selectedTimesheetHasChanges)

  }, [props.selectedTimesheetHasChanges]) // eslint-disable-line react-hooks/exhaustive-deps

  const onSelectedChange = (timesheet?: TimesheetItem, forceChange: boolean = false) => {

    if (props.selectedTimesheetHasChanges && !forceChange) {
      SetToSelectTimesheet(timesheet)
      setOpenConfirmationModal(true)
      return
    }
    setSelectedTimeSheets(timesheet ? [timesheet] : [])
    if (props.onSelectTimeSheet) props.onSelectTimeSheet(timesheet)
  }

  useMemo(() => {
    let selected = FilterYears()
    if (selected.length > 0) {
      setSelectedYears([selected[0] + ""])
    }

  }, [periodFilter]) // eslint-disable-line react-hooks/exhaustive-deps


  const RestartComponent = async (projectFilter: string[], statusFilter: string[]) => {
    setIsLoading(true)
    setSearch('')
    setSelectedYears([])
    setYears([])

    var mm = await timesheetDataStore.getMaxMIn(props.companyId, props.employeeId, false, projectFilter, statusFilter) as any
    BuildCalendar(mm.item1, mm.item2)
    setIsLoading(false)
  }


  useMemo(() => {
    if (projectFilter || statusFilter) {
      RestartComponent(projectFilter || [], statusFilter || [])
    }

  }, [projectFilter, statusFilter]) // eslint-disable-line react-hooks/exhaustive-deps

  useMemo(() => {
    if (props.fullReaload > 0) {
      RestartComponent(projectFilter || [], statusFilter || [])
    }

  }, [props.fullReaload]) // eslint-disable-line react-hooks/exhaustive-deps

  const filterHeader = (<h5 style={{ marginTop: 6 }} >{t('Advanced search')} </h5>)

  const customExpandIcon = (props: any) => {
    if (props.isActive) {
      return <a style={{ color: 'black' }} ><Icon type="close" /></a>
    } else {
      return <a style={{ color: 'black' }} ><Icon type="search" /></a>
    }
  }

  const GroupRender = (title: string) => {

    let isSelected = selectedYears.any(x => x == title)
    return (<Card
      className={`ibox ${(isSelected) ? "external-group-selected" : "external-group"}`
      }
      style={{
        padding: 10,
        width: "100%",
        textAlign: "center",
      }}>
      <b className="fi-dark-blue-color">{title}</b>
    </Card>)
  }

  const handleDropdownVisibleChange = (open: boolean) => {
    if (open && projects.length === 0) {
      setSearch('')
    }
  }

  return <><Popover
    trigger="click"
    content={
      <>
        <div>
          {sortDirection == "asc" && <Button style={{ float: "right", width: "32px", }} onClick={() => { setSordirection("desc") }} icon={'sort-ascending'} />}
          {sortDirection == "desc" && <Button style={{ float: "right", width: "32px", }} onClick={() => { setSordirection("asc") }} icon={'sort-descending'} />}
        </div>
        <div style={{ marginRight: "32px" }}>
          <Select style={{ width: "100%", height: 32 }} placeholder={t('Order by')} onChange={(value: "date" | "progress") => { setSortBy(value) }} defaultValue={'date'}>
            <Option value="date">{t("Sort by date")}</Option>
            <Option value="progress">{t("Sort by progress")}</Option>
          </Select>
        </div>
        <div className="team-timesheets-period-select">
          <Select
            mode="multiple"
            style={{ width: '100%', borderColor: '#364966', marginTop: '4px' }}
            placeholder={t('Projects ...')}
            onChange={(value: any) => { setProjectFilter(value) }}
            filterOption={false}
            value={projectFilter}
            onSearch={(value: any) => { setSearch(value) }}
            dropdownRender={total > projects.length ? (menu) => dropdownRender(menu, total, projects.length) : undefined}
            onDropdownVisibleChange={handleDropdownVisibleChange}
            loading={loading}
          >
            {projectFilterSource().map((value, index) => {
              return <Option value={value}>{value}</Option>
            })}

          </Select>
          <Select
            mode="multiple"
            style={{ width: '100%', borderColor: '#364966', marginTop: '4px' }}
            placeholder={t('Period ...')}
            onChange={(value: any) => { setPeriodFilter(value) }}
            defaultValue={periodFilter}>
            {(years || []).map((value, index) => {
              return <Option value={value + ""}>{value + ""}</Option>
            })}

          </Select>
          <Select
            mode="multiple"
            style={{ marginTop: '4px', width: '100%', borderColor: '#364966' }}
            placeholder={t('Timesheet status ...')}
            onChange={(value: any) => { setStatusFilter(value) }}
            defaultValue={statusFilter}>
            <Option value={"Draft"}>{t("Draft")}</Option>
            <Option value={"Pending"}>{t("Pending")}</Option>
            <Option value={"Approved"}>{t("Approved")}</Option>
            <Option value={"Rejected"}>{t("Rejected")}</Option>

          </Select>
          <Checkbox checked={incompletes} style={{ marginBottom: 4, marginTop: 4 }} onChange={(e) => { setIncompletes(!incompletes) }}><span>{t("Incomplete timesheets")}</span></Checkbox>
        </div>
      </>
    }
  >
    <Tooltip title={t("Advanced search")}>
      <Button shape="circle" disabled={!showFilter} style={{ position: "absolute", zIndex: 99999, right: 0 }} icon={'search'} type="primary"></Button>
    </Tooltip>
  </Popover>
    <div className={"timesheet-calendar-container"}>
      <Spin spinning={isLoading}>

        {years && years.length > 0 && FilterYears().length > 0 ?
          <Collapse
            className="custom-collapse-header"
            onChange={(key) => setSelectedYears(key)}
            style={{ width: "100%", padding: 0 }}
            bordered={false}
            activeKey={selectedYears}
          >
            {FilterYears().map((y, index) => {
              return (


                <Panel
                  showArrow={false}
                  key={y}
                  header={GroupRender(y + "")}
                  className='list-group'
                  style={customPanelStyle}>
                  <TimeSheetYear incompletes={incompletes} statusFilter={statusFilter ?? []} projectsFilter={projectFilter ?? []} sortDirection={sortDirection} sortBy={sortBy} selectedTimeSheets={selectedTimesheets.map(x => x.id)} onSelectTimeSheets={(timesheet?: TimesheetItem) => { onSelectedChange(timesheet) }} openFirst={index == 0} year={y} initDate={minDate} maxDate={maxDate}  {...props}></TimeSheetYear>
                </Panel>

              )
            })}
          </Collapse>
          :
          <Empty style={{ marginTop: 20 }} />
        }
      </Spin>

    </div>
    <Modal
      visible={openConfirmationModal}
      closable={false}
      onOk={() => {
        setOpenConfirmationModal(false)
        onSelectedChange(toSelectTimesheet, true)
      }}
      onCancel={() => setOpenConfirmationModal(false)}
      okText={t("Ok")}
      cancelText={t("Cancel")}
      title={t('Confirmation required')}>
      <div>
        <p>
          {t("You have pending changes to save. Do you want to continue?")}
        </p>
      </div>
    </Modal>
  </>
}



export interface TimeSheetYearProps extends WithTranslation, IdentityProps, UserProfileProps {
  employeeId: string,
  companyId: string,
  year: number
  initDate?: Date,
  maxDate?: Date,
  showMyTeam?: boolean,
  openFirst?: boolean,
  onSelectTimeSheets?: (timesheet?: TimesheetItem) => void,
  selectedTimeSheets: string[],
  reload: number
  sortDirection: "asc" | "desc",
  sortBy: "date" | "progress",
  projectsFilter: string[]
  statusFilter: string[]
  incompletes: boolean
}


const TimeSheetYear: FC<TimeSheetYearProps> = ({
  identity,
  t,
  employeeId,
  companyId,
  year,
  initDate,
  showMyTeam,
  maxDate,
  openFirst,
  onSelectTimeSheets,
  selectedTimeSheets,
  reload,
  sortBy,
  sortDirection,
  statusFilter,
  incompletes,
  projectsFilter

}) => {
  const timesheetDataStore = container.get<MyTimesheetsStore>(MyTimesheetsStore)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [calendar, setCalendar] = useState<TimeSheetCalendarItem[]>()
  const [selectedKeys, setSelectedKeys] = useState<string | string[]>([])
  const [localselectedTimesheets, setSelectedTimeSheets] = useState<string[]>([])
  const [filterSortBy, setFilterSortBy] = useState<"date" | "progress">(sortBy)
  const [filterSortDirection, setFilterSortDirection] = useState<"asc" | "desc">(sortDirection)
  const [filterInc, setFilterInc] = useState<boolean>(incompletes)

  useMemo(() => {
    setFilterSortDirection(sortDirection)
    setFilterSortBy(sortBy)
    setFilterInc(incompletes)
  }, [sortDirection, sortBy, incompletes]) // eslint-disable-line react-hooks/exhaustive-deps



  useMemo(() => {
    setSelectedTimeSheets(selectedTimeSheets.filter(x => calendar?.any(y => y.timesheets.any(z => z.id == x))))

  }, [selectedTimeSheets]) // eslint-disable-line react-hooks/exhaustive-deps

  var ref = useRef()

  const BuildCalendar = async () => {

    let initMonth = year == maxDate?.getFullYear() ? maxDate?.getMonth() : 11
    let periods = []
    do {

      periods.push({ month: initMonth, timesheets: [], monthTitle: moment().month(initMonth).format("MMMM"), open: false })
    } while (initMonth-- > (initDate?.getFullYear() == year ? initDate?.getMonth() : 0))

    if (openFirst) {
      if (periods.length > 0) { }
      setCalendar(periods)
      let opens = [periods[0].month + ""]
      await onOpenMonth(opens, periods, true)
      return
    }
    setCalendar(periods)


  }
  const customPanelStyle = {
    borderRadius: 1,
    marginBottom: 2,
    width: "100%",
    padding: "0px 10px 0px 10px",
    border: 0,
  }

  const Load = async () => {
    BuildCalendar()
    setIsLoading(false)
  }


  const GetSource = (timesheets: TimesheetItem[]) => {

    if (statusFilter.length > 0) {
      timesheets = timesheets.filter(t => statusFilter.any(x => x == t.status))
    }
    if (filterInc) {
      timesheets = timesheets.filter(item => incSheet(item))
    }
    if (filterSortBy == 'date')
      return filterSortDirection == 'asc' ? timesheets.orderBy(t => t.fromDate).toArray() as TimesheetItem[] : timesheets.orderByDescending(t => t.fromDate).toArray() as TimesheetItem[]
    else {
      const sortedItems = timesheets.sort((a: TimesheetItem, b: TimesheetItem) => ((a.minHours > 0 ?
        (a.totalHours * 100 / a.minHours) :
        (a.totalHours > 0 ? 100 : 0)) - (b.minHours > 0 ?
          (b.totalHours * 100 / b.minHours) :
          (b.totalHours > 0 ? 100 : 0))))

      return filterSortDirection == 'asc' ? sortedItems.toArray() as TimesheetItem[] : sortedItems.reverse().toArray() as TimesheetItem[]
    }


  }


  const onOpenMonth = async (keys: string[], currentCalendar: TimeSheetCalendarItem[], selectFirst: boolean = false) => {

    let filter = currentCalendar?.firstOrDefault(x => !x.open && keys.any(y => x.month + "" == y))
    if (filter) {
      setIsLoading(true)
      let initDate = new Date(year, filter.month, -5)
      let toDate = new Date(year, filter.month + 1, 0)
      var timesheets = await timesheetDataStore.GetTimeSheets(companyId, employeeId, showMyTeam == true, initDate.toDateString(), toDate.toDateString(), projectsFilter)
      filter.timesheets = timesheets
      filter.open = true
      setCalendar(currentCalendar)
      if (selectFirst) {
        if (onSelectTimeSheets) {
          var toSee = GetSource(timesheets)
          SelectTimeSheet(toSee.length > 0 ? toSee.firstOrDefault(x => !x.inFuture) ?? toSee[0] : undefined)
        }
      }
      setIsLoading(false)
    }
    setSelectedKeys(keys)
  }

  useMemo(() => {
    if (reload > 1) {
      if (selectedTimeSheets.length > 0) {
        let selected = selectedTimeSheets[0]
        var currentcalendar = calendar
        let selectedCalendar = currentcalendar?.firstOrDefault(x => x.timesheets.any(y => y.id == selected))
        if (selectedCalendar) {
          selectedCalendar.open = false
          onOpenMonth(selectedKeys as any, currentcalendar as any)
        }
      }
    }
  }, [reload]) // eslint-disable-line react-hooks/exhaustive-deps

  useMemo(() => {
    Load()
  }, [ref]) // eslint-disable-line react-hooks/exhaustive-deps

  const GroupRender = (title: string, isSelected: boolean) => {
    return (<Card
      className={`ibox ${(isSelected) ? "fi-dark-blue-back" : ""}`}
      style={{
        marginTop: -10,
        padding: 5,
        width: "100%",
        textAlign: "center",
      }}>
      <b className={(isSelected) ? "" : "fi-dark-blue-color"} style={(isSelected) ? { color: "white" } : {}}>{t(title)}</b>
    </Card>)
  }

  const SelectTimeSheet = (timesheet?: TimesheetItem) => {
    if (onSelectTimeSheets) {
      onSelectTimeSheets(timesheet)
    }
  }





  const itemRender = (innerItem: TimesheetSummary) => {
    return (
      <React.Fragment>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <StatusView status={innerItem.status} iconOnly style={{ fontSize: '1.5em' }} t={t} />
          <Divider style={{ height: '2.5em' }} type="vertical" />
        </div>
        <div style={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
          <span> {moment.utc(innerItem.fromDate).locale(i18n.language).format('MMMM Do, YYYY')} </span>
          <span> {moment.utc(innerItem.toDate).locale(i18n.language).format('MMMM Do, YYYY')} </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Divider style={{ height: '2.5em' }} type="vertical" />
          <div style={{ marginRight: 15 }}>
            <span style={{ display: 'block', fontSize: '1.5em' }}>
              {formatDecimal(innerItem.totalHours)}
            </span>
            <small style={{ display: 'block', marginTop: -4 }}>
              {t('hrs').toUpperCase()}
            </small>
          </div>
        </div>
        {innerItem.minHours > 0 &&
          <Tooltip title={formatDecimal(innerItem.percentage ? innerItem.percentage : 0).concat("%")}>
            <Progress
              type={"circle"}
              percent={Number(Number(innerItem.percentage ? innerItem.percentage : 0).toFixed(0))}
              width={40} />
          </Tooltip>}
      </React.Fragment>)
  }

  const incSheet = (item: any) => {
    return item.status == "Draft" && (item.totalHours < item.minHours || item.minHours == 0) 
  }

  const TimesheetClassName = (item: TimesheetSummary) => {
    let className = "timesheet-item "
    className += localselectedTimesheets.any(x => x == item.id) ? 'selected ' : " "
    className += item.inFuture ? "inFuture " : " "
    return className;
  }

  if (calendar && calendar.length > 0) {
    return <Spin spinning={isLoading}>

      <Collapse
        className="custom-collapse-header"
        onChange={(key) => onOpenMonth(key as any, calendar)}
        style={{ width: "100%", padding: 0 }}
        bordered={false}
        activeKey={selectedKeys}
      >
        {calendar.map(g => {
          return (
            <Panel
              showArrow={false}
              key={g.month}
              header={GroupRender(g.monthTitle + "", selectedKeys.any(x => x == g.month + ""))}
              className='list-group'
              style={customPanelStyle}>
              <List
                itemLayout="horizontal"
                dataSource={GetSource(g.timesheets)}
                renderItem={item => (
                  <List.Item
                    style={{ justifyContent: 'space-between' }}
                    className={TimesheetClassName(item)}
                    onClick={() => { SelectTimeSheet(item) }}>
                    {itemRender(item as TimesheetSummary)}
                  </List.Item>
                )}
              />
            </Panel>
          )
        })}
      </Collapse> </Spin>
  } else {
    return <Spin spinning={isLoading}><Empty style={{ marginTop: 20 }} /></Spin>

  }
}

export default withUserProfile(withIdentity(withTranslation()(TimeSheetCalendar) as any)) as any
